// SPDX-FileCopyrightText: 2026 Ebiose AI
// SPDX-License-Identifier: LicenseRef-Ebiose-Proprietary
// All rights reserved. Confidential — unauthorized distribution prohibited.

import { format } from "date-fns"
import { enGB } from "date-fns/locale"

const EM_DASH = "—"

const parsedInstant = (iso: string | null | undefined): Date | null => {
  if (!iso) return null
  const t = Date.parse(iso)
  return Number.isFinite(t) ? new Date(t) : null
}

export const formatDateTime = (iso: string | null | undefined): string => {
  const date = parsedInstant(iso)
  return date ? date.toLocaleString() : EM_DASH
}

export const formatDate = (iso: string | null | undefined): string => {
  const date = parsedInstant(iso)
  return date ? format(date, "d MMM yyyy", { locale: enGB }) : EM_DASH
}
